module.exports = __webpack_public_path__ + "static/media/icon-gif.9de28264.svg";